import { MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import DiscoveryFilters, { DiscoveryFilterValues } from "@/components/discovery/DiscoveryFilters";
import HamburgerMenu from "@/components/pop-balloon/HamburgerMenu";

interface PopBalloonHeaderProps {
  filters: DiscoveryFilterValues;
  onFiltersChange: (filters: Partial<DiscoveryFilterValues>) => void;
  hasLocation: boolean;
  onRequestLocation: () => Promise<void>;
  onRestoreProfile: () => void;
  onRestoreHiddenProfile: () => void;
  onResetDiscoveryPreferences: () => void;
  unreadCount?: number;
}

const PopBalloonHeader = ({
  filters,
  onFiltersChange,
  hasLocation,
  onRequestLocation,
  onRestoreProfile,
  onRestoreHiddenProfile,
  onResetDiscoveryPreferences,
  unreadCount = 0,
}: PopBalloonHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="bg-background border-b border-border/50 shadow-sm">
      <div className="flex items-center justify-between px-4 py-2 safe-area-top">
        {/* Left side - Compact Filter Pill */}
        <DiscoveryFilters
          filters={filters}
          onFiltersChange={onFiltersChange}
          hasLocation={hasLocation}
          onRequestLocation={onRequestLocation}
          variant="searchbar"
        />

        {/* Right side - Messages + Hamburger */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate("/matches")}
            className="relative h-10 w-10 rounded-full bg-muted/50 hover:bg-muted border border-border/50 flex items-center justify-center transition-colors"
            aria-label="Messages"
          >
            <MessageCircle className="h-5 w-5 text-foreground" />
            {unreadCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] bg-pop text-white text-xs font-bold rounded-full flex items-center justify-center px-1">
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </button>
          <HamburgerMenu
            onRestoreProfile={onRestoreProfile}
            onRestoreHiddenProfile={onRestoreHiddenProfile}
            onResetDiscoveryPreferences={onResetDiscoveryPreferences}
          />
        </div>
      </div>
    </div>
  );
};

export default PopBalloonHeader;
